import React from "react";
import CategoryPage from "./CategoryPage";

export default function DoorSecurityPage() {
  return (
    <CategoryPage
      categoryMatch="door security"
      title="Door Security"
      subtitle="High-security locks, cylinders, and hardware for residential and commercial doors."
      searchPlaceholder="Search door security..."
    />
  );
}